import CategoryPage from './CategoryPage'
import { withCategoryPage } from './withCategoryPage'

const ConnectedCategoryPage = withCategoryPage(CategoryPage)

export { ConnectedCategoryPage as CategoryPage }
